import React from "react";
import { defaultFonts } from "../../../helpers/fonts";
import colors from "../../../helpers/colors";
import { Typography } from "@mui/material";
import PbErrorMessageProps from "./PbErrorMessageProps.type";

const PbErrorMessage = (props: PbErrorMessageProps) => {
  return (
    <Typography
      color={
        props.isWarning ? colors.warning.background : colors.danger.background
      }
      fontFamily={defaultFonts}
      fontWeight={props.bigText ? "800" : "400"}
      style={{ margin: "5px" }}
    >
      {props.message}
    </Typography>
  );
};

export default PbErrorMessage;
